import $ from 'jquery';
import selectize from 'selectize';

$(() => {
  $('.country-select').selectize();
  const $cSelect = $('.country-filter').selectize({
    create: false,
    valueField: 'id',
    labelField: 'name',
    sortField: 'name',
  });
  if ($cSelect.length > 0) {
    const countries = $cSelect[0].selectize;
    countries.disable();
  }

  $('.product-select').selectize({
    onChange: () => {
      $('.aside-wrap .button').removeClass('added');
      $('.product-side-panel .added-to-basket').removeClass('opened');
    },
  });

  $('.js-added-to-basket').click((e) => {
    e.preventDefault();
    $(this).addClass('added');
    $('.added-to-basket').addClass('opened');
  });

  if ($('.sites-filter').length > 0) {
    selectize.define('option_click', function(options) { // eslint-disable-line
      const self = this;
      const setup = self.setup;
      this.setup = () => {
        setup.apply(self, arguments); // eslint-disable-line prefer-rest-params

        let clicking = false;

        // Detect click on a .clickable
        self.$dropdown_content.on('mousedown click', (e) => {
          if ($(e.target).hasClass('clickable')) {
            if (e.type === 'mousedown') {
              clicking = true;
              self.isFocused = false; // awful hack to defuse the document mousedown listener
            } else {
              self.isFocused = true;
              setTimeout(() => {
                clicking = false; // wait until blur has been preempted
              });
            }
          } else { // cleanup in case user right-clicked or dragged off the element
            clicking = false;
            self.isFocused = true;
          }
        });

        // Intercept default handlers
        self.$dropdown.off('mousedown click', '[data-selectable]').on('mousedown click', '[data-selectable]', () => { // eslint-disable-line
          if (!clicking) {
            return self.onOptionSelect.apply(self, arguments); // eslint-disable-line
          }
        });
        self.$control_input.off('blur').on('blur', () => { // eslint-disable-line consistent-return
          if (!clicking) {
            return self.onBlur.apply(self, arguments); // eslint-disable-line
          }
        });
      };
    });

    $('.sites-filter').selectize({
      valueField: 'value',
      labelField: 'name',
      plugins: ['option_click'],
      placeholder: 'Our other websites',
      render: {
        option(item, escape) {
          return `<div><a href="${item.value}" target="_blank" class="clickable">${escape(item.name)}</a></div>`;
        },
      },
    });
    $('.sites-filter .selectize-input input').prop('disabled', true);
  }

  $(() => {
    const $cSelectSearch = $('#search-filter').selectize({// eslint-disable-line no-unused-vars
      create: true,
    });
  });

  $('.basket-quantity-select').selectize({// eslint-disable-line no-unused-vars
    create: true,
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/custom-select.js
 **/